/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as SetsIndexImport } from './routes/sets/index'
import { Route as PublishIndexImport } from './routes/publish/index'
import { Route as MyBankIndexImport } from './routes/my-bank/index'
import { Route as EvalIndexImport } from './routes/eval/index'
import { Route as EditIndexImport } from './routes/edit/index'
import { Route as DashboardIndexImport } from './routes/dashboard/index'
import { Route as CreateIndexImport } from './routes/create/index'
import { Route as CreateSetIndexImport } from './routes/create-set/index'
import { Route as EvalErrorExpiredImport } from './routes/eval/error-expired'
import { Route as EvalError404Import } from './routes/eval/error-404'
import { Route as EvalReadyImport } from './routes/eval/Ready'
import { Route as EvalCompleteImport } from './routes/eval/Complete'
import { Route as SetsPublishedBoxIndexImport } from './routes/sets/published-box/index'
import { Route as SetsPodIndexImport } from './routes/sets/pod/index'
import { Route as SetsPodV2IndexImport } from './routes/sets/pod-v2/index'
import { Route as SetsCreatedBoxIndexImport } from './routes/sets/created-box/index'
import { Route as ReportStntsIndexImport } from './routes/report/stnts/index'
import { Route as ReportStntIndexImport } from './routes/report/stnt/index'
import { Route as PublishHomeworkIndexImport } from './routes/publish/Homework/index'
import { Route as CreateImportViewIndexImport } from './routes/create/import-view/index'
import { Route as PublishMyPublicationsCaseSearchNoResultImport } from './routes/publish/MyPublications/CaseSearchNoResult'
import { Route as PublishMyPublicationsCaseNoDataImport } from './routes/publish/MyPublications/CaseNoData'
import { Route as PublishHomeworkQrNoticeImport } from './routes/publish/Homework/QrNotice'
import { Route as PublishHomeworkPasswordResetImport } from './routes/publish/Homework/PasswordReset'
import { Route as PublishHomeworkLoginImport } from './routes/publish/Homework/Login'
import { Route as PublishHomeworkEvalCompleteImport } from './routes/publish/Homework/EvalComplete'
import { Route as PublishHomeworkError502Import } from './routes/publish/Homework/Error502'
import { Route as PublishHomeworkError404Import } from './routes/publish/Homework/Error404'
import { Route as PublishMyPublicationsReportDetailIndexImport } from './routes/publish/MyPublications/ReportDetail/index'
import { Route as PublishMyPublicationsPublishedListsIndexImport } from './routes/publish/MyPublications/PublishedLists/index'
import { Route as PublishMyPublicationsNicknameListsIndexImport } from './routes/publish/MyPublications/NicknameLists/index'
import { Route as PublishMyPublicationsClassListsIndexImport } from './routes/publish/MyPublications/ClassLists/index'
import { Route as SetsPublishedBoxDetailPublishIdImport } from './routes/sets/published-box/detail/$publishId'
import { Route as SetsPodRePreviewPublishIdImport } from './routes/sets/pod/re-preview/$publishId'
import { Route as SetsPodPreviewPublishGrpIdImport } from './routes/sets/pod/preview/$publishGrpId'
import { Route as SetsCreatedBoxDetailExamIdImport } from './routes/sets/created-box/detail/$examId'
import { Route as PublishMyPublicationsPublishedListsStudentReportImport } from './routes/publish/MyPublications/PublishedLists/StudentReport'
import { Route as PublishMyPublicationsClassListsPersonalPageImport } from './routes/publish/MyPublications/ClassLists/PersonalPage'
import { Route as EvalReportEvalIdStntIdImport } from './routes/eval/report/$evalId.$stntId'
import { Route as ReportEvalGubunEvalReportIndexImport } from './routes/report/eval/$gubun._eval._report.index'
import { Route as PublishHomeworkInfoViewStepPageIndexImport } from './routes/publish/Homework/InfoView/$step/$page/index'
import { Route as PublishMyPublicationsPublishedDetailUsePageCaseTabIndexImport } from './routes/publish/MyPublications/PublishedDetail/$use/$page/$case/$tab/index'

// Create/Update Routes

const SetsIndexRoute = SetsIndexImport.update({
  id: '/sets/',
  path: '/sets/',
  getParentRoute: () => rootRoute,
} as any)

const PublishIndexRoute = PublishIndexImport.update({
  id: '/publish/',
  path: '/publish/',
  getParentRoute: () => rootRoute,
} as any)

const MyBankIndexRoute = MyBankIndexImport.update({
  id: '/my-bank/',
  path: '/my-bank/',
  getParentRoute: () => rootRoute,
} as any)

const EvalIndexRoute = EvalIndexImport.update({
  id: '/eval/',
  path: '/eval/',
  getParentRoute: () => rootRoute,
} as any)

const EditIndexRoute = EditIndexImport.update({
  id: '/edit/',
  path: '/edit/',
  getParentRoute: () => rootRoute,
} as any)

const DashboardIndexRoute = DashboardIndexImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => rootRoute,
} as any)

const CreateIndexRoute = CreateIndexImport.update({
  id: '/create/',
  path: '/create/',
  getParentRoute: () => rootRoute,
} as any)

const CreateSetIndexRoute = CreateSetIndexImport.update({
  id: '/create-set/',
  path: '/create-set/',
  getParentRoute: () => rootRoute,
} as any)

const EvalErrorExpiredRoute = EvalErrorExpiredImport.update({
  id: '/eval/error-expired',
  path: '/eval/error-expired',
  getParentRoute: () => rootRoute,
} as any)

const EvalError404Route = EvalError404Import.update({
  id: '/eval/error-404',
  path: '/eval/error-404',
  getParentRoute: () => rootRoute,
} as any)

const EvalReadyRoute = EvalReadyImport.update({
  id: '/eval/Ready',
  path: '/eval/Ready',
  getParentRoute: () => rootRoute,
} as any)

const EvalCompleteRoute = EvalCompleteImport.update({
  id: '/eval/Complete',
  path: '/eval/Complete',
  getParentRoute: () => rootRoute,
} as any)

const SetsPublishedBoxIndexRoute = SetsPublishedBoxIndexImport.update({
  id: '/sets/published-box/',
  path: '/sets/published-box/',
  getParentRoute: () => rootRoute,
} as any)

const SetsPodIndexRoute = SetsPodIndexImport.update({
  id: '/sets/pod/',
  path: '/sets/pod/',
  getParentRoute: () => rootRoute,
} as any)

const SetsPodV2IndexRoute = SetsPodV2IndexImport.update({
  id: '/sets/pod-v2/',
  path: '/sets/pod-v2/',
  getParentRoute: () => rootRoute,
} as any)

const SetsCreatedBoxIndexRoute = SetsCreatedBoxIndexImport.update({
  id: '/sets/created-box/',
  path: '/sets/created-box/',
  getParentRoute: () => rootRoute,
} as any)

const ReportStntsIndexRoute = ReportStntsIndexImport.update({
  id: '/report/stnts/',
  path: '/report/stnts/',
  getParentRoute: () => rootRoute,
} as any)

const ReportStntIndexRoute = ReportStntIndexImport.update({
  id: '/report/stnt/',
  path: '/report/stnt/',
  getParentRoute: () => rootRoute,
} as any)

const PublishHomeworkIndexRoute = PublishHomeworkIndexImport.update({
  id: '/publish/Homework/',
  path: '/publish/Homework/',
  getParentRoute: () => rootRoute,
} as any)

const CreateImportViewIndexRoute = CreateImportViewIndexImport.update({
  id: '/create/import-view/',
  path: '/create/import-view/',
  getParentRoute: () => rootRoute,
} as any)

const PublishMyPublicationsCaseSearchNoResultRoute =
  PublishMyPublicationsCaseSearchNoResultImport.update({
    id: '/publish/MyPublications/CaseSearchNoResult',
    path: '/publish/MyPublications/CaseSearchNoResult',
    getParentRoute: () => rootRoute,
  } as any)

const PublishMyPublicationsCaseNoDataRoute =
  PublishMyPublicationsCaseNoDataImport.update({
    id: '/publish/MyPublications/CaseNoData',
    path: '/publish/MyPublications/CaseNoData',
    getParentRoute: () => rootRoute,
  } as any)

const PublishHomeworkQrNoticeRoute = PublishHomeworkQrNoticeImport.update({
  id: '/publish/Homework/QrNotice',
  path: '/publish/Homework/QrNotice',
  getParentRoute: () => rootRoute,
} as any)

const PublishHomeworkPasswordResetRoute =
  PublishHomeworkPasswordResetImport.update({
    id: '/publish/Homework/PasswordReset',
    path: '/publish/Homework/PasswordReset',
    getParentRoute: () => rootRoute,
  } as any)

const PublishHomeworkLoginRoute = PublishHomeworkLoginImport.update({
  id: '/publish/Homework/Login',
  path: '/publish/Homework/Login',
  getParentRoute: () => rootRoute,
} as any)

const PublishHomeworkEvalCompleteRoute =
  PublishHomeworkEvalCompleteImport.update({
    id: '/publish/Homework/EvalComplete',
    path: '/publish/Homework/EvalComplete',
    getParentRoute: () => rootRoute,
  } as any)

const PublishHomeworkError502Route = PublishHomeworkError502Import.update({
  id: '/publish/Homework/Error502',
  path: '/publish/Homework/Error502',
  getParentRoute: () => rootRoute,
} as any)

const PublishHomeworkError404Route = PublishHomeworkError404Import.update({
  id: '/publish/Homework/Error404',
  path: '/publish/Homework/Error404',
  getParentRoute: () => rootRoute,
} as any)

const PublishMyPublicationsReportDetailIndexRoute =
  PublishMyPublicationsReportDetailIndexImport.update({
    id: '/publish/MyPublications/ReportDetail/',
    path: '/publish/MyPublications/ReportDetail/',
    getParentRoute: () => rootRoute,
  } as any)

const PublishMyPublicationsPublishedListsIndexRoute =
  PublishMyPublicationsPublishedListsIndexImport.update({
    id: '/publish/MyPublications/PublishedLists/',
    path: '/publish/MyPublications/PublishedLists/',
    getParentRoute: () => rootRoute,
  } as any)

const PublishMyPublicationsNicknameListsIndexRoute =
  PublishMyPublicationsNicknameListsIndexImport.update({
    id: '/publish/MyPublications/NicknameLists/',
    path: '/publish/MyPublications/NicknameLists/',
    getParentRoute: () => rootRoute,
  } as any)

const PublishMyPublicationsClassListsIndexRoute =
  PublishMyPublicationsClassListsIndexImport.update({
    id: '/publish/MyPublications/ClassLists/',
    path: '/publish/MyPublications/ClassLists/',
    getParentRoute: () => rootRoute,
  } as any)

const SetsPublishedBoxDetailPublishIdRoute =
  SetsPublishedBoxDetailPublishIdImport.update({
    id: '/sets/published-box/detail/$publishId',
    path: '/sets/published-box/detail/$publishId',
    getParentRoute: () => rootRoute,
  } as any)

const SetsPodRePreviewPublishIdRoute = SetsPodRePreviewPublishIdImport.update({
  id: '/sets/pod/re-preview/$publishId',
  path: '/sets/pod/re-preview/$publishId',
  getParentRoute: () => rootRoute,
} as any)

const SetsPodPreviewPublishGrpIdRoute = SetsPodPreviewPublishGrpIdImport.update(
  {
    id: '/sets/pod/preview/$publishGrpId',
    path: '/sets/pod/preview/$publishGrpId',
    getParentRoute: () => rootRoute,
  } as any,
)

const SetsCreatedBoxDetailExamIdRoute = SetsCreatedBoxDetailExamIdImport.update(
  {
    id: '/sets/created-box/detail/$examId',
    path: '/sets/created-box/detail/$examId',
    getParentRoute: () => rootRoute,
  } as any,
)

const PublishMyPublicationsPublishedListsStudentReportRoute =
  PublishMyPublicationsPublishedListsStudentReportImport.update({
    id: '/publish/MyPublications/PublishedLists/StudentReport',
    path: '/publish/MyPublications/PublishedLists/StudentReport',
    getParentRoute: () => rootRoute,
  } as any)

const PublishMyPublicationsClassListsPersonalPageRoute =
  PublishMyPublicationsClassListsPersonalPageImport.update({
    id: '/publish/MyPublications/ClassLists/PersonalPage',
    path: '/publish/MyPublications/ClassLists/PersonalPage',
    getParentRoute: () => rootRoute,
  } as any)

const EvalReportEvalIdStntIdRoute = EvalReportEvalIdStntIdImport.update({
  id: '/eval/report/$evalId/$stntId',
  path: '/eval/report/$evalId/$stntId',
  getParentRoute: () => rootRoute,
} as any)

const ReportEvalGubunEvalReportIndexRoute =
  ReportEvalGubunEvalReportIndexImport.update({
    id: '/report/eval/$gubun/_eval/_report/',
    path: '/report/eval/$gubun/',
    getParentRoute: () => rootRoute,
  } as any)

const PublishHomeworkInfoViewStepPageIndexRoute =
  PublishHomeworkInfoViewStepPageIndexImport.update({
    id: '/publish/Homework/InfoView/$step/$page/',
    path: '/publish/Homework/InfoView/$step/$page/',
    getParentRoute: () => rootRoute,
  } as any)

const PublishMyPublicationsPublishedDetailUsePageCaseTabIndexRoute =
  PublishMyPublicationsPublishedDetailUsePageCaseTabIndexImport.update({
    id: '/publish/MyPublications/PublishedDetail/$use/$page/$case/$tab/',
    path: '/publish/MyPublications/PublishedDetail/$use/$page/$case/$tab/',
    getParentRoute: () => rootRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/eval/Complete': {
      id: '/eval/Complete'
      path: '/eval/Complete'
      fullPath: '/eval/Complete'
      preLoaderRoute: typeof EvalCompleteImport
      parentRoute: typeof rootRoute
    }
    '/eval/Ready': {
      id: '/eval/Ready'
      path: '/eval/Ready'
      fullPath: '/eval/Ready'
      preLoaderRoute: typeof EvalReadyImport
      parentRoute: typeof rootRoute
    }
    '/eval/error-404': {
      id: '/eval/error-404'
      path: '/eval/error-404'
      fullPath: '/eval/error-404'
      preLoaderRoute: typeof EvalError404Import
      parentRoute: typeof rootRoute
    }
    '/eval/error-expired': {
      id: '/eval/error-expired'
      path: '/eval/error-expired'
      fullPath: '/eval/error-expired'
      preLoaderRoute: typeof EvalErrorExpiredImport
      parentRoute: typeof rootRoute
    }
    '/create-set/': {
      id: '/create-set/'
      path: '/create-set'
      fullPath: '/create-set'
      preLoaderRoute: typeof CreateSetIndexImport
      parentRoute: typeof rootRoute
    }
    '/create/': {
      id: '/create/'
      path: '/create'
      fullPath: '/create'
      preLoaderRoute: typeof CreateIndexImport
      parentRoute: typeof rootRoute
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardIndexImport
      parentRoute: typeof rootRoute
    }
    '/edit/': {
      id: '/edit/'
      path: '/edit'
      fullPath: '/edit'
      preLoaderRoute: typeof EditIndexImport
      parentRoute: typeof rootRoute
    }
    '/eval/': {
      id: '/eval/'
      path: '/eval'
      fullPath: '/eval'
      preLoaderRoute: typeof EvalIndexImport
      parentRoute: typeof rootRoute
    }
    '/my-bank/': {
      id: '/my-bank/'
      path: '/my-bank'
      fullPath: '/my-bank'
      preLoaderRoute: typeof MyBankIndexImport
      parentRoute: typeof rootRoute
    }
    '/publish/': {
      id: '/publish/'
      path: '/publish'
      fullPath: '/publish'
      preLoaderRoute: typeof PublishIndexImport
      parentRoute: typeof rootRoute
    }
    '/sets/': {
      id: '/sets/'
      path: '/sets'
      fullPath: '/sets'
      preLoaderRoute: typeof SetsIndexImport
      parentRoute: typeof rootRoute
    }
    '/publish/Homework/Error404': {
      id: '/publish/Homework/Error404'
      path: '/publish/Homework/Error404'
      fullPath: '/publish/Homework/Error404'
      preLoaderRoute: typeof PublishHomeworkError404Import
      parentRoute: typeof rootRoute
    }
    '/publish/Homework/Error502': {
      id: '/publish/Homework/Error502'
      path: '/publish/Homework/Error502'
      fullPath: '/publish/Homework/Error502'
      preLoaderRoute: typeof PublishHomeworkError502Import
      parentRoute: typeof rootRoute
    }
    '/publish/Homework/EvalComplete': {
      id: '/publish/Homework/EvalComplete'
      path: '/publish/Homework/EvalComplete'
      fullPath: '/publish/Homework/EvalComplete'
      preLoaderRoute: typeof PublishHomeworkEvalCompleteImport
      parentRoute: typeof rootRoute
    }
    '/publish/Homework/Login': {
      id: '/publish/Homework/Login'
      path: '/publish/Homework/Login'
      fullPath: '/publish/Homework/Login'
      preLoaderRoute: typeof PublishHomeworkLoginImport
      parentRoute: typeof rootRoute
    }
    '/publish/Homework/PasswordReset': {
      id: '/publish/Homework/PasswordReset'
      path: '/publish/Homework/PasswordReset'
      fullPath: '/publish/Homework/PasswordReset'
      preLoaderRoute: typeof PublishHomeworkPasswordResetImport
      parentRoute: typeof rootRoute
    }
    '/publish/Homework/QrNotice': {
      id: '/publish/Homework/QrNotice'
      path: '/publish/Homework/QrNotice'
      fullPath: '/publish/Homework/QrNotice'
      preLoaderRoute: typeof PublishHomeworkQrNoticeImport
      parentRoute: typeof rootRoute
    }
    '/publish/MyPublications/CaseNoData': {
      id: '/publish/MyPublications/CaseNoData'
      path: '/publish/MyPublications/CaseNoData'
      fullPath: '/publish/MyPublications/CaseNoData'
      preLoaderRoute: typeof PublishMyPublicationsCaseNoDataImport
      parentRoute: typeof rootRoute
    }
    '/publish/MyPublications/CaseSearchNoResult': {
      id: '/publish/MyPublications/CaseSearchNoResult'
      path: '/publish/MyPublications/CaseSearchNoResult'
      fullPath: '/publish/MyPublications/CaseSearchNoResult'
      preLoaderRoute: typeof PublishMyPublicationsCaseSearchNoResultImport
      parentRoute: typeof rootRoute
    }
    '/create/import-view/': {
      id: '/create/import-view/'
      path: '/create/import-view'
      fullPath: '/create/import-view'
      preLoaderRoute: typeof CreateImportViewIndexImport
      parentRoute: typeof rootRoute
    }
    '/publish/Homework/': {
      id: '/publish/Homework/'
      path: '/publish/Homework'
      fullPath: '/publish/Homework'
      preLoaderRoute: typeof PublishHomeworkIndexImport
      parentRoute: typeof rootRoute
    }
    '/report/stnt/': {
      id: '/report/stnt/'
      path: '/report/stnt'
      fullPath: '/report/stnt'
      preLoaderRoute: typeof ReportStntIndexImport
      parentRoute: typeof rootRoute
    }
    '/report/stnts/': {
      id: '/report/stnts/'
      path: '/report/stnts'
      fullPath: '/report/stnts'
      preLoaderRoute: typeof ReportStntsIndexImport
      parentRoute: typeof rootRoute
    }
    '/sets/created-box/': {
      id: '/sets/created-box/'
      path: '/sets/created-box'
      fullPath: '/sets/created-box'
      preLoaderRoute: typeof SetsCreatedBoxIndexImport
      parentRoute: typeof rootRoute
    }
    '/sets/pod-v2/': {
      id: '/sets/pod-v2/'
      path: '/sets/pod-v2'
      fullPath: '/sets/pod-v2'
      preLoaderRoute: typeof SetsPodV2IndexImport
      parentRoute: typeof rootRoute
    }
    '/sets/pod/': {
      id: '/sets/pod/'
      path: '/sets/pod'
      fullPath: '/sets/pod'
      preLoaderRoute: typeof SetsPodIndexImport
      parentRoute: typeof rootRoute
    }
    '/sets/published-box/': {
      id: '/sets/published-box/'
      path: '/sets/published-box'
      fullPath: '/sets/published-box'
      preLoaderRoute: typeof SetsPublishedBoxIndexImport
      parentRoute: typeof rootRoute
    }
    '/eval/report/$evalId/$stntId': {
      id: '/eval/report/$evalId/$stntId'
      path: '/eval/report/$evalId/$stntId'
      fullPath: '/eval/report/$evalId/$stntId'
      preLoaderRoute: typeof EvalReportEvalIdStntIdImport
      parentRoute: typeof rootRoute
    }
    '/publish/MyPublications/ClassLists/PersonalPage': {
      id: '/publish/MyPublications/ClassLists/PersonalPage'
      path: '/publish/MyPublications/ClassLists/PersonalPage'
      fullPath: '/publish/MyPublications/ClassLists/PersonalPage'
      preLoaderRoute: typeof PublishMyPublicationsClassListsPersonalPageImport
      parentRoute: typeof rootRoute
    }
    '/publish/MyPublications/PublishedLists/StudentReport': {
      id: '/publish/MyPublications/PublishedLists/StudentReport'
      path: '/publish/MyPublications/PublishedLists/StudentReport'
      fullPath: '/publish/MyPublications/PublishedLists/StudentReport'
      preLoaderRoute: typeof PublishMyPublicationsPublishedListsStudentReportImport
      parentRoute: typeof rootRoute
    }
    '/sets/created-box/detail/$examId': {
      id: '/sets/created-box/detail/$examId'
      path: '/sets/created-box/detail/$examId'
      fullPath: '/sets/created-box/detail/$examId'
      preLoaderRoute: typeof SetsCreatedBoxDetailExamIdImport
      parentRoute: typeof rootRoute
    }
    '/sets/pod/preview/$publishGrpId': {
      id: '/sets/pod/preview/$publishGrpId'
      path: '/sets/pod/preview/$publishGrpId'
      fullPath: '/sets/pod/preview/$publishGrpId'
      preLoaderRoute: typeof SetsPodPreviewPublishGrpIdImport
      parentRoute: typeof rootRoute
    }
    '/sets/pod/re-preview/$publishId': {
      id: '/sets/pod/re-preview/$publishId'
      path: '/sets/pod/re-preview/$publishId'
      fullPath: '/sets/pod/re-preview/$publishId'
      preLoaderRoute: typeof SetsPodRePreviewPublishIdImport
      parentRoute: typeof rootRoute
    }
    '/sets/published-box/detail/$publishId': {
      id: '/sets/published-box/detail/$publishId'
      path: '/sets/published-box/detail/$publishId'
      fullPath: '/sets/published-box/detail/$publishId'
      preLoaderRoute: typeof SetsPublishedBoxDetailPublishIdImport
      parentRoute: typeof rootRoute
    }
    '/publish/MyPublications/ClassLists/': {
      id: '/publish/MyPublications/ClassLists/'
      path: '/publish/MyPublications/ClassLists'
      fullPath: '/publish/MyPublications/ClassLists'
      preLoaderRoute: typeof PublishMyPublicationsClassListsIndexImport
      parentRoute: typeof rootRoute
    }
    '/publish/MyPublications/NicknameLists/': {
      id: '/publish/MyPublications/NicknameLists/'
      path: '/publish/MyPublications/NicknameLists'
      fullPath: '/publish/MyPublications/NicknameLists'
      preLoaderRoute: typeof PublishMyPublicationsNicknameListsIndexImport
      parentRoute: typeof rootRoute
    }
    '/publish/MyPublications/PublishedLists/': {
      id: '/publish/MyPublications/PublishedLists/'
      path: '/publish/MyPublications/PublishedLists'
      fullPath: '/publish/MyPublications/PublishedLists'
      preLoaderRoute: typeof PublishMyPublicationsPublishedListsIndexImport
      parentRoute: typeof rootRoute
    }
    '/publish/MyPublications/ReportDetail/': {
      id: '/publish/MyPublications/ReportDetail/'
      path: '/publish/MyPublications/ReportDetail'
      fullPath: '/publish/MyPublications/ReportDetail'
      preLoaderRoute: typeof PublishMyPublicationsReportDetailIndexImport
      parentRoute: typeof rootRoute
    }
    '/publish/Homework/InfoView/$step/$page/': {
      id: '/publish/Homework/InfoView/$step/$page/'
      path: '/publish/Homework/InfoView/$step/$page'
      fullPath: '/publish/Homework/InfoView/$step/$page'
      preLoaderRoute: typeof PublishHomeworkInfoViewStepPageIndexImport
      parentRoute: typeof rootRoute
    }
    '/report/eval/$gubun/_eval/_report/': {
      id: '/report/eval/$gubun/_eval/_report/'
      path: '/report/eval/$gubun'
      fullPath: '/report/eval/$gubun'
      preLoaderRoute: typeof ReportEvalGubunEvalReportIndexImport
      parentRoute: typeof rootRoute
    }
    '/publish/MyPublications/PublishedDetail/$use/$page/$case/$tab/': {
      id: '/publish/MyPublications/PublishedDetail/$use/$page/$case/$tab/'
      path: '/publish/MyPublications/PublishedDetail/$use/$page/$case/$tab'
      fullPath: '/publish/MyPublications/PublishedDetail/$use/$page/$case/$tab'
      preLoaderRoute: typeof PublishMyPublicationsPublishedDetailUsePageCaseTabIndexImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/eval/Complete': typeof EvalCompleteRoute
  '/eval/Ready': typeof EvalReadyRoute
  '/eval/error-404': typeof EvalError404Route
  '/eval/error-expired': typeof EvalErrorExpiredRoute
  '/create-set': typeof CreateSetIndexRoute
  '/create': typeof CreateIndexRoute
  '/dashboard': typeof DashboardIndexRoute
  '/edit': typeof EditIndexRoute
  '/eval': typeof EvalIndexRoute
  '/my-bank': typeof MyBankIndexRoute
  '/publish': typeof PublishIndexRoute
  '/sets': typeof SetsIndexRoute
  '/publish/Homework/Error404': typeof PublishHomeworkError404Route
  '/publish/Homework/Error502': typeof PublishHomeworkError502Route
  '/publish/Homework/EvalComplete': typeof PublishHomeworkEvalCompleteRoute
  '/publish/Homework/Login': typeof PublishHomeworkLoginRoute
  '/publish/Homework/PasswordReset': typeof PublishHomeworkPasswordResetRoute
  '/publish/Homework/QrNotice': typeof PublishHomeworkQrNoticeRoute
  '/publish/MyPublications/CaseNoData': typeof PublishMyPublicationsCaseNoDataRoute
  '/publish/MyPublications/CaseSearchNoResult': typeof PublishMyPublicationsCaseSearchNoResultRoute
  '/create/import-view': typeof CreateImportViewIndexRoute
  '/publish/Homework': typeof PublishHomeworkIndexRoute
  '/report/stnt': typeof ReportStntIndexRoute
  '/report/stnts': typeof ReportStntsIndexRoute
  '/sets/created-box': typeof SetsCreatedBoxIndexRoute
  '/sets/pod-v2': typeof SetsPodV2IndexRoute
  '/sets/pod': typeof SetsPodIndexRoute
  '/sets/published-box': typeof SetsPublishedBoxIndexRoute
  '/eval/report/$evalId/$stntId': typeof EvalReportEvalIdStntIdRoute
  '/publish/MyPublications/ClassLists/PersonalPage': typeof PublishMyPublicationsClassListsPersonalPageRoute
  '/publish/MyPublications/PublishedLists/StudentReport': typeof PublishMyPublicationsPublishedListsStudentReportRoute
  '/sets/created-box/detail/$examId': typeof SetsCreatedBoxDetailExamIdRoute
  '/sets/pod/preview/$publishGrpId': typeof SetsPodPreviewPublishGrpIdRoute
  '/sets/pod/re-preview/$publishId': typeof SetsPodRePreviewPublishIdRoute
  '/sets/published-box/detail/$publishId': typeof SetsPublishedBoxDetailPublishIdRoute
  '/publish/MyPublications/ClassLists': typeof PublishMyPublicationsClassListsIndexRoute
  '/publish/MyPublications/NicknameLists': typeof PublishMyPublicationsNicknameListsIndexRoute
  '/publish/MyPublications/PublishedLists': typeof PublishMyPublicationsPublishedListsIndexRoute
  '/publish/MyPublications/ReportDetail': typeof PublishMyPublicationsReportDetailIndexRoute
  '/publish/Homework/InfoView/$step/$page': typeof PublishHomeworkInfoViewStepPageIndexRoute
  '/report/eval/$gubun': typeof ReportEvalGubunEvalReportIndexRoute
  '/publish/MyPublications/PublishedDetail/$use/$page/$case/$tab': typeof PublishMyPublicationsPublishedDetailUsePageCaseTabIndexRoute
}

export interface FileRoutesByTo {
  '/eval/Complete': typeof EvalCompleteRoute
  '/eval/Ready': typeof EvalReadyRoute
  '/eval/error-404': typeof EvalError404Route
  '/eval/error-expired': typeof EvalErrorExpiredRoute
  '/create-set': typeof CreateSetIndexRoute
  '/create': typeof CreateIndexRoute
  '/dashboard': typeof DashboardIndexRoute
  '/edit': typeof EditIndexRoute
  '/eval': typeof EvalIndexRoute
  '/my-bank': typeof MyBankIndexRoute
  '/publish': typeof PublishIndexRoute
  '/sets': typeof SetsIndexRoute
  '/publish/Homework/Error404': typeof PublishHomeworkError404Route
  '/publish/Homework/Error502': typeof PublishHomeworkError502Route
  '/publish/Homework/EvalComplete': typeof PublishHomeworkEvalCompleteRoute
  '/publish/Homework/Login': typeof PublishHomeworkLoginRoute
  '/publish/Homework/PasswordReset': typeof PublishHomeworkPasswordResetRoute
  '/publish/Homework/QrNotice': typeof PublishHomeworkQrNoticeRoute
  '/publish/MyPublications/CaseNoData': typeof PublishMyPublicationsCaseNoDataRoute
  '/publish/MyPublications/CaseSearchNoResult': typeof PublishMyPublicationsCaseSearchNoResultRoute
  '/create/import-view': typeof CreateImportViewIndexRoute
  '/publish/Homework': typeof PublishHomeworkIndexRoute
  '/report/stnt': typeof ReportStntIndexRoute
  '/report/stnts': typeof ReportStntsIndexRoute
  '/sets/created-box': typeof SetsCreatedBoxIndexRoute
  '/sets/pod-v2': typeof SetsPodV2IndexRoute
  '/sets/pod': typeof SetsPodIndexRoute
  '/sets/published-box': typeof SetsPublishedBoxIndexRoute
  '/eval/report/$evalId/$stntId': typeof EvalReportEvalIdStntIdRoute
  '/publish/MyPublications/ClassLists/PersonalPage': typeof PublishMyPublicationsClassListsPersonalPageRoute
  '/publish/MyPublications/PublishedLists/StudentReport': typeof PublishMyPublicationsPublishedListsStudentReportRoute
  '/sets/created-box/detail/$examId': typeof SetsCreatedBoxDetailExamIdRoute
  '/sets/pod/preview/$publishGrpId': typeof SetsPodPreviewPublishGrpIdRoute
  '/sets/pod/re-preview/$publishId': typeof SetsPodRePreviewPublishIdRoute
  '/sets/published-box/detail/$publishId': typeof SetsPublishedBoxDetailPublishIdRoute
  '/publish/MyPublications/ClassLists': typeof PublishMyPublicationsClassListsIndexRoute
  '/publish/MyPublications/NicknameLists': typeof PublishMyPublicationsNicknameListsIndexRoute
  '/publish/MyPublications/PublishedLists': typeof PublishMyPublicationsPublishedListsIndexRoute
  '/publish/MyPublications/ReportDetail': typeof PublishMyPublicationsReportDetailIndexRoute
  '/publish/Homework/InfoView/$step/$page': typeof PublishHomeworkInfoViewStepPageIndexRoute
  '/report/eval/$gubun': typeof ReportEvalGubunEvalReportIndexRoute
  '/publish/MyPublications/PublishedDetail/$use/$page/$case/$tab': typeof PublishMyPublicationsPublishedDetailUsePageCaseTabIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/eval/Complete': typeof EvalCompleteRoute
  '/eval/Ready': typeof EvalReadyRoute
  '/eval/error-404': typeof EvalError404Route
  '/eval/error-expired': typeof EvalErrorExpiredRoute
  '/create-set/': typeof CreateSetIndexRoute
  '/create/': typeof CreateIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/edit/': typeof EditIndexRoute
  '/eval/': typeof EvalIndexRoute
  '/my-bank/': typeof MyBankIndexRoute
  '/publish/': typeof PublishIndexRoute
  '/sets/': typeof SetsIndexRoute
  '/publish/Homework/Error404': typeof PublishHomeworkError404Route
  '/publish/Homework/Error502': typeof PublishHomeworkError502Route
  '/publish/Homework/EvalComplete': typeof PublishHomeworkEvalCompleteRoute
  '/publish/Homework/Login': typeof PublishHomeworkLoginRoute
  '/publish/Homework/PasswordReset': typeof PublishHomeworkPasswordResetRoute
  '/publish/Homework/QrNotice': typeof PublishHomeworkQrNoticeRoute
  '/publish/MyPublications/CaseNoData': typeof PublishMyPublicationsCaseNoDataRoute
  '/publish/MyPublications/CaseSearchNoResult': typeof PublishMyPublicationsCaseSearchNoResultRoute
  '/create/import-view/': typeof CreateImportViewIndexRoute
  '/publish/Homework/': typeof PublishHomeworkIndexRoute
  '/report/stnt/': typeof ReportStntIndexRoute
  '/report/stnts/': typeof ReportStntsIndexRoute
  '/sets/created-box/': typeof SetsCreatedBoxIndexRoute
  '/sets/pod-v2/': typeof SetsPodV2IndexRoute
  '/sets/pod/': typeof SetsPodIndexRoute
  '/sets/published-box/': typeof SetsPublishedBoxIndexRoute
  '/eval/report/$evalId/$stntId': typeof EvalReportEvalIdStntIdRoute
  '/publish/MyPublications/ClassLists/PersonalPage': typeof PublishMyPublicationsClassListsPersonalPageRoute
  '/publish/MyPublications/PublishedLists/StudentReport': typeof PublishMyPublicationsPublishedListsStudentReportRoute
  '/sets/created-box/detail/$examId': typeof SetsCreatedBoxDetailExamIdRoute
  '/sets/pod/preview/$publishGrpId': typeof SetsPodPreviewPublishGrpIdRoute
  '/sets/pod/re-preview/$publishId': typeof SetsPodRePreviewPublishIdRoute
  '/sets/published-box/detail/$publishId': typeof SetsPublishedBoxDetailPublishIdRoute
  '/publish/MyPublications/ClassLists/': typeof PublishMyPublicationsClassListsIndexRoute
  '/publish/MyPublications/NicknameLists/': typeof PublishMyPublicationsNicknameListsIndexRoute
  '/publish/MyPublications/PublishedLists/': typeof PublishMyPublicationsPublishedListsIndexRoute
  '/publish/MyPublications/ReportDetail/': typeof PublishMyPublicationsReportDetailIndexRoute
  '/publish/Homework/InfoView/$step/$page/': typeof PublishHomeworkInfoViewStepPageIndexRoute
  '/report/eval/$gubun/_eval/_report/': typeof ReportEvalGubunEvalReportIndexRoute
  '/publish/MyPublications/PublishedDetail/$use/$page/$case/$tab/': typeof PublishMyPublicationsPublishedDetailUsePageCaseTabIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/eval/Complete'
    | '/eval/Ready'
    | '/eval/error-404'
    | '/eval/error-expired'
    | '/create-set'
    | '/create'
    | '/dashboard'
    | '/edit'
    | '/eval'
    | '/my-bank'
    | '/publish'
    | '/sets'
    | '/publish/Homework/Error404'
    | '/publish/Homework/Error502'
    | '/publish/Homework/EvalComplete'
    | '/publish/Homework/Login'
    | '/publish/Homework/PasswordReset'
    | '/publish/Homework/QrNotice'
    | '/publish/MyPublications/CaseNoData'
    | '/publish/MyPublications/CaseSearchNoResult'
    | '/create/import-view'
    | '/publish/Homework'
    | '/report/stnt'
    | '/report/stnts'
    | '/sets/created-box'
    | '/sets/pod-v2'
    | '/sets/pod'
    | '/sets/published-box'
    | '/eval/report/$evalId/$stntId'
    | '/publish/MyPublications/ClassLists/PersonalPage'
    | '/publish/MyPublications/PublishedLists/StudentReport'
    | '/sets/created-box/detail/$examId'
    | '/sets/pod/preview/$publishGrpId'
    | '/sets/pod/re-preview/$publishId'
    | '/sets/published-box/detail/$publishId'
    | '/publish/MyPublications/ClassLists'
    | '/publish/MyPublications/NicknameLists'
    | '/publish/MyPublications/PublishedLists'
    | '/publish/MyPublications/ReportDetail'
    | '/publish/Homework/InfoView/$step/$page'
    | '/report/eval/$gubun'
    | '/publish/MyPublications/PublishedDetail/$use/$page/$case/$tab'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/eval/Complete'
    | '/eval/Ready'
    | '/eval/error-404'
    | '/eval/error-expired'
    | '/create-set'
    | '/create'
    | '/dashboard'
    | '/edit'
    | '/eval'
    | '/my-bank'
    | '/publish'
    | '/sets'
    | '/publish/Homework/Error404'
    | '/publish/Homework/Error502'
    | '/publish/Homework/EvalComplete'
    | '/publish/Homework/Login'
    | '/publish/Homework/PasswordReset'
    | '/publish/Homework/QrNotice'
    | '/publish/MyPublications/CaseNoData'
    | '/publish/MyPublications/CaseSearchNoResult'
    | '/create/import-view'
    | '/publish/Homework'
    | '/report/stnt'
    | '/report/stnts'
    | '/sets/created-box'
    | '/sets/pod-v2'
    | '/sets/pod'
    | '/sets/published-box'
    | '/eval/report/$evalId/$stntId'
    | '/publish/MyPublications/ClassLists/PersonalPage'
    | '/publish/MyPublications/PublishedLists/StudentReport'
    | '/sets/created-box/detail/$examId'
    | '/sets/pod/preview/$publishGrpId'
    | '/sets/pod/re-preview/$publishId'
    | '/sets/published-box/detail/$publishId'
    | '/publish/MyPublications/ClassLists'
    | '/publish/MyPublications/NicknameLists'
    | '/publish/MyPublications/PublishedLists'
    | '/publish/MyPublications/ReportDetail'
    | '/publish/Homework/InfoView/$step/$page'
    | '/report/eval/$gubun'
    | '/publish/MyPublications/PublishedDetail/$use/$page/$case/$tab'
  id:
    | '__root__'
    | '/eval/Complete'
    | '/eval/Ready'
    | '/eval/error-404'
    | '/eval/error-expired'
    | '/create-set/'
    | '/create/'
    | '/dashboard/'
    | '/edit/'
    | '/eval/'
    | '/my-bank/'
    | '/publish/'
    | '/sets/'
    | '/publish/Homework/Error404'
    | '/publish/Homework/Error502'
    | '/publish/Homework/EvalComplete'
    | '/publish/Homework/Login'
    | '/publish/Homework/PasswordReset'
    | '/publish/Homework/QrNotice'
    | '/publish/MyPublications/CaseNoData'
    | '/publish/MyPublications/CaseSearchNoResult'
    | '/create/import-view/'
    | '/publish/Homework/'
    | '/report/stnt/'
    | '/report/stnts/'
    | '/sets/created-box/'
    | '/sets/pod-v2/'
    | '/sets/pod/'
    | '/sets/published-box/'
    | '/eval/report/$evalId/$stntId'
    | '/publish/MyPublications/ClassLists/PersonalPage'
    | '/publish/MyPublications/PublishedLists/StudentReport'
    | '/sets/created-box/detail/$examId'
    | '/sets/pod/preview/$publishGrpId'
    | '/sets/pod/re-preview/$publishId'
    | '/sets/published-box/detail/$publishId'
    | '/publish/MyPublications/ClassLists/'
    | '/publish/MyPublications/NicknameLists/'
    | '/publish/MyPublications/PublishedLists/'
    | '/publish/MyPublications/ReportDetail/'
    | '/publish/Homework/InfoView/$step/$page/'
    | '/report/eval/$gubun/_eval/_report/'
    | '/publish/MyPublications/PublishedDetail/$use/$page/$case/$tab/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  EvalCompleteRoute: typeof EvalCompleteRoute
  EvalReadyRoute: typeof EvalReadyRoute
  EvalError404Route: typeof EvalError404Route
  EvalErrorExpiredRoute: typeof EvalErrorExpiredRoute
  CreateSetIndexRoute: typeof CreateSetIndexRoute
  CreateIndexRoute: typeof CreateIndexRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  EditIndexRoute: typeof EditIndexRoute
  EvalIndexRoute: typeof EvalIndexRoute
  MyBankIndexRoute: typeof MyBankIndexRoute
  PublishIndexRoute: typeof PublishIndexRoute
  SetsIndexRoute: typeof SetsIndexRoute
  PublishHomeworkError404Route: typeof PublishHomeworkError404Route
  PublishHomeworkError502Route: typeof PublishHomeworkError502Route
  PublishHomeworkEvalCompleteRoute: typeof PublishHomeworkEvalCompleteRoute
  PublishHomeworkLoginRoute: typeof PublishHomeworkLoginRoute
  PublishHomeworkPasswordResetRoute: typeof PublishHomeworkPasswordResetRoute
  PublishHomeworkQrNoticeRoute: typeof PublishHomeworkQrNoticeRoute
  PublishMyPublicationsCaseNoDataRoute: typeof PublishMyPublicationsCaseNoDataRoute
  PublishMyPublicationsCaseSearchNoResultRoute: typeof PublishMyPublicationsCaseSearchNoResultRoute
  CreateImportViewIndexRoute: typeof CreateImportViewIndexRoute
  PublishHomeworkIndexRoute: typeof PublishHomeworkIndexRoute
  ReportStntIndexRoute: typeof ReportStntIndexRoute
  ReportStntsIndexRoute: typeof ReportStntsIndexRoute
  SetsCreatedBoxIndexRoute: typeof SetsCreatedBoxIndexRoute
  SetsPodV2IndexRoute: typeof SetsPodV2IndexRoute
  SetsPodIndexRoute: typeof SetsPodIndexRoute
  SetsPublishedBoxIndexRoute: typeof SetsPublishedBoxIndexRoute
  EvalReportEvalIdStntIdRoute: typeof EvalReportEvalIdStntIdRoute
  PublishMyPublicationsClassListsPersonalPageRoute: typeof PublishMyPublicationsClassListsPersonalPageRoute
  PublishMyPublicationsPublishedListsStudentReportRoute: typeof PublishMyPublicationsPublishedListsStudentReportRoute
  SetsCreatedBoxDetailExamIdRoute: typeof SetsCreatedBoxDetailExamIdRoute
  SetsPodPreviewPublishGrpIdRoute: typeof SetsPodPreviewPublishGrpIdRoute
  SetsPodRePreviewPublishIdRoute: typeof SetsPodRePreviewPublishIdRoute
  SetsPublishedBoxDetailPublishIdRoute: typeof SetsPublishedBoxDetailPublishIdRoute
  PublishMyPublicationsClassListsIndexRoute: typeof PublishMyPublicationsClassListsIndexRoute
  PublishMyPublicationsNicknameListsIndexRoute: typeof PublishMyPublicationsNicknameListsIndexRoute
  PublishMyPublicationsPublishedListsIndexRoute: typeof PublishMyPublicationsPublishedListsIndexRoute
  PublishMyPublicationsReportDetailIndexRoute: typeof PublishMyPublicationsReportDetailIndexRoute
  PublishHomeworkInfoViewStepPageIndexRoute: typeof PublishHomeworkInfoViewStepPageIndexRoute
  ReportEvalGubunEvalReportIndexRoute: typeof ReportEvalGubunEvalReportIndexRoute
  PublishMyPublicationsPublishedDetailUsePageCaseTabIndexRoute: typeof PublishMyPublicationsPublishedDetailUsePageCaseTabIndexRoute
}

const rootRouteChildren: RootRouteChildren = {
  EvalCompleteRoute: EvalCompleteRoute,
  EvalReadyRoute: EvalReadyRoute,
  EvalError404Route: EvalError404Route,
  EvalErrorExpiredRoute: EvalErrorExpiredRoute,
  CreateSetIndexRoute: CreateSetIndexRoute,
  CreateIndexRoute: CreateIndexRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  EditIndexRoute: EditIndexRoute,
  EvalIndexRoute: EvalIndexRoute,
  MyBankIndexRoute: MyBankIndexRoute,
  PublishIndexRoute: PublishIndexRoute,
  SetsIndexRoute: SetsIndexRoute,
  PublishHomeworkError404Route: PublishHomeworkError404Route,
  PublishHomeworkError502Route: PublishHomeworkError502Route,
  PublishHomeworkEvalCompleteRoute: PublishHomeworkEvalCompleteRoute,
  PublishHomeworkLoginRoute: PublishHomeworkLoginRoute,
  PublishHomeworkPasswordResetRoute: PublishHomeworkPasswordResetRoute,
  PublishHomeworkQrNoticeRoute: PublishHomeworkQrNoticeRoute,
  PublishMyPublicationsCaseNoDataRoute: PublishMyPublicationsCaseNoDataRoute,
  PublishMyPublicationsCaseSearchNoResultRoute:
    PublishMyPublicationsCaseSearchNoResultRoute,
  CreateImportViewIndexRoute: CreateImportViewIndexRoute,
  PublishHomeworkIndexRoute: PublishHomeworkIndexRoute,
  ReportStntIndexRoute: ReportStntIndexRoute,
  ReportStntsIndexRoute: ReportStntsIndexRoute,
  SetsCreatedBoxIndexRoute: SetsCreatedBoxIndexRoute,
  SetsPodV2IndexRoute: SetsPodV2IndexRoute,
  SetsPodIndexRoute: SetsPodIndexRoute,
  SetsPublishedBoxIndexRoute: SetsPublishedBoxIndexRoute,
  EvalReportEvalIdStntIdRoute: EvalReportEvalIdStntIdRoute,
  PublishMyPublicationsClassListsPersonalPageRoute:
    PublishMyPublicationsClassListsPersonalPageRoute,
  PublishMyPublicationsPublishedListsStudentReportRoute:
    PublishMyPublicationsPublishedListsStudentReportRoute,
  SetsCreatedBoxDetailExamIdRoute: SetsCreatedBoxDetailExamIdRoute,
  SetsPodPreviewPublishGrpIdRoute: SetsPodPreviewPublishGrpIdRoute,
  SetsPodRePreviewPublishIdRoute: SetsPodRePreviewPublishIdRoute,
  SetsPublishedBoxDetailPublishIdRoute: SetsPublishedBoxDetailPublishIdRoute,
  PublishMyPublicationsClassListsIndexRoute:
    PublishMyPublicationsClassListsIndexRoute,
  PublishMyPublicationsNicknameListsIndexRoute:
    PublishMyPublicationsNicknameListsIndexRoute,
  PublishMyPublicationsPublishedListsIndexRoute:
    PublishMyPublicationsPublishedListsIndexRoute,
  PublishMyPublicationsReportDetailIndexRoute:
    PublishMyPublicationsReportDetailIndexRoute,
  PublishHomeworkInfoViewStepPageIndexRoute:
    PublishHomeworkInfoViewStepPageIndexRoute,
  ReportEvalGubunEvalReportIndexRoute: ReportEvalGubunEvalReportIndexRoute,
  PublishMyPublicationsPublishedDetailUsePageCaseTabIndexRoute:
    PublishMyPublicationsPublishedDetailUsePageCaseTabIndexRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/eval/Complete",
        "/eval/Ready",
        "/eval/error-404",
        "/eval/error-expired",
        "/create-set/",
        "/create/",
        "/dashboard/",
        "/edit/",
        "/eval/",
        "/my-bank/",
        "/publish/",
        "/sets/",
        "/publish/Homework/Error404",
        "/publish/Homework/Error502",
        "/publish/Homework/EvalComplete",
        "/publish/Homework/Login",
        "/publish/Homework/PasswordReset",
        "/publish/Homework/QrNotice",
        "/publish/MyPublications/CaseNoData",
        "/publish/MyPublications/CaseSearchNoResult",
        "/create/import-view/",
        "/publish/Homework/",
        "/report/stnt/",
        "/report/stnts/",
        "/sets/created-box/",
        "/sets/pod-v2/",
        "/sets/pod/",
        "/sets/published-box/",
        "/eval/report/$evalId/$stntId",
        "/publish/MyPublications/ClassLists/PersonalPage",
        "/publish/MyPublications/PublishedLists/StudentReport",
        "/sets/created-box/detail/$examId",
        "/sets/pod/preview/$publishGrpId",
        "/sets/pod/re-preview/$publishId",
        "/sets/published-box/detail/$publishId",
        "/publish/MyPublications/ClassLists/",
        "/publish/MyPublications/NicknameLists/",
        "/publish/MyPublications/PublishedLists/",
        "/publish/MyPublications/ReportDetail/",
        "/publish/Homework/InfoView/$step/$page/",
        "/report/eval/$gubun/_eval/_report/",
        "/publish/MyPublications/PublishedDetail/$use/$page/$case/$tab/"
      ]
    },
    "/eval/Complete": {
      "filePath": "eval/Complete.tsx"
    },
    "/eval/Ready": {
      "filePath": "eval/Ready.tsx"
    },
    "/eval/error-404": {
      "filePath": "eval/error-404.tsx"
    },
    "/eval/error-expired": {
      "filePath": "eval/error-expired.tsx"
    },
    "/create-set/": {
      "filePath": "create-set/index.tsx"
    },
    "/create/": {
      "filePath": "create/index.tsx"
    },
    "/dashboard/": {
      "filePath": "dashboard/index.tsx"
    },
    "/edit/": {
      "filePath": "edit/index.tsx"
    },
    "/eval/": {
      "filePath": "eval/index.tsx"
    },
    "/my-bank/": {
      "filePath": "my-bank/index.tsx"
    },
    "/publish/": {
      "filePath": "publish/index.tsx"
    },
    "/sets/": {
      "filePath": "sets/index.tsx"
    },
    "/publish/Homework/Error404": {
      "filePath": "publish/Homework/Error404.tsx"
    },
    "/publish/Homework/Error502": {
      "filePath": "publish/Homework/Error502.tsx"
    },
    "/publish/Homework/EvalComplete": {
      "filePath": "publish/Homework/EvalComplete.tsx"
    },
    "/publish/Homework/Login": {
      "filePath": "publish/Homework/Login.tsx"
    },
    "/publish/Homework/PasswordReset": {
      "filePath": "publish/Homework/PasswordReset.tsx"
    },
    "/publish/Homework/QrNotice": {
      "filePath": "publish/Homework/QrNotice.tsx"
    },
    "/publish/MyPublications/CaseNoData": {
      "filePath": "publish/MyPublications/CaseNoData.tsx"
    },
    "/publish/MyPublications/CaseSearchNoResult": {
      "filePath": "publish/MyPublications/CaseSearchNoResult.tsx"
    },
    "/create/import-view/": {
      "filePath": "create/import-view/index.tsx"
    },
    "/publish/Homework/": {
      "filePath": "publish/Homework/index.tsx"
    },
    "/report/stnt/": {
      "filePath": "report/stnt/index.tsx"
    },
    "/report/stnts/": {
      "filePath": "report/stnts/index.tsx"
    },
    "/sets/created-box/": {
      "filePath": "sets/created-box/index.tsx"
    },
    "/sets/pod-v2/": {
      "filePath": "sets/pod-v2/index.tsx"
    },
    "/sets/pod/": {
      "filePath": "sets/pod/index.tsx"
    },
    "/sets/published-box/": {
      "filePath": "sets/published-box/index.tsx"
    },
    "/eval/report/$evalId/$stntId": {
      "filePath": "eval/report/$evalId.$stntId.tsx"
    },
    "/publish/MyPublications/ClassLists/PersonalPage": {
      "filePath": "publish/MyPublications/ClassLists/PersonalPage.tsx"
    },
    "/publish/MyPublications/PublishedLists/StudentReport": {
      "filePath": "publish/MyPublications/PublishedLists/StudentReport.tsx"
    },
    "/sets/created-box/detail/$examId": {
      "filePath": "sets/created-box/detail/$examId.tsx"
    },
    "/sets/pod/preview/$publishGrpId": {
      "filePath": "sets/pod/preview/$publishGrpId.tsx"
    },
    "/sets/pod/re-preview/$publishId": {
      "filePath": "sets/pod/re-preview/$publishId.tsx"
    },
    "/sets/published-box/detail/$publishId": {
      "filePath": "sets/published-box/detail/$publishId.tsx"
    },
    "/publish/MyPublications/ClassLists/": {
      "filePath": "publish/MyPublications/ClassLists/index.tsx"
    },
    "/publish/MyPublications/NicknameLists/": {
      "filePath": "publish/MyPublications/NicknameLists/index.tsx"
    },
    "/publish/MyPublications/PublishedLists/": {
      "filePath": "publish/MyPublications/PublishedLists/index.tsx"
    },
    "/publish/MyPublications/ReportDetail/": {
      "filePath": "publish/MyPublications/ReportDetail/index.tsx"
    },
    "/publish/Homework/InfoView/$step/$page/": {
      "filePath": "publish/Homework/InfoView/$step/$page/index.tsx"
    },
    "/report/eval/$gubun/_eval/_report/": {
      "filePath": "report/eval/$gubun._eval._report.index.tsx"
    },
    "/publish/MyPublications/PublishedDetail/$use/$page/$case/$tab/": {
      "filePath": "publish/MyPublications/PublishedDetail/$use/$page/$case/$tab/index.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
